import { useOpenModal } from './useOpenModal'
import { useTranslations } from './useTranslations'
import { handleLocalStorage } from '../utils/handleLocalStorage'
import BranchPicker from '../../padges/Welcome/BranchPicker'
import GUIDPicker from '../../padges/Welcome/GUIDPicker'
import TimePicker from '../../padges/Welcome/TimePicker'
import { ConfirmationModal } from 'featureSliced/features/ConfirmationModal'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useNavigate } from 'react-router-dom'

export const usePromptParams = () => {
  const t = useTranslations()
  const openModal = useOpenModal()
  const navigate = useNavigate()
  const appTheme = useMySelector((state) => state.app.interfaceStyles.appTheme)

  const openPromptModal = (
    loadApp: () => void,
    neededSteps = ['guid', 'time', 'branch'],
    shouldHideCross = false
  ) => {
    console.log(' neededSteps:', neededSteps)
    const onClose = async (closeSearchParams: () => void) => {
      const { guid, dataEnc } = handleLocalStorage(['guid', 'dataEnc'])
      if (guid || dataEnc) {
        closeSearchParams()
        await loadApp()
        if (location.pathname === '/welcome') {
          navigate('/')
        }
      } else {
        // toast.error(t('errors.tryScanner'))

        let qrCodeErrorJSON: any
        try {
          qrCodeErrorJSON = await import(
            `assets/lotties/${appTheme}/callWaiter.json`
          )
        } catch (e) {
          qrCodeErrorJSON = await import(
            'assets/lotties/light/failedOrder.json'
          )
        }

        openModal({
          id: 'TRY_SCANNER_MODAL',
          title: '',
          components: [
            ({ closeThisModal }) => (
              <ConfirmationModal
                onConfirm={closeThisModal}
                animationJSON={qrCodeErrorJSON}
                text={t('errors.tryScanner')}
              />
            ),
          ],
        })
      }
    }

    openModal({
      id: 'SEARCH_PARAMS_PROMPT',
      title: ``,
      shouldHideCross,
      components: [
        ...(neededSteps.includes('guid')
          ? [
              ({ onNext, closeThisModal }: any) => (
                <GUIDPicker
                  increaseStep={() => {
                    if (
                      neededSteps.includes('time') ||
                      neededSteps.includes('branch')
                    ) {
                      onNext()
                    } else {
                      onClose(closeThisModal)
                    }
                  }}
                />
              ),
            ]
          : []),
        ...(process.env.REACT_APP_IS_CLIC === '1' &&
        neededSteps.includes('time')
          ? [
              ({ onNext, closeThisModal }: any) => (
                <TimePicker
                  increaseStep={() => {
                    if (neededSteps.includes('branch')) {
                      onNext()
                    } else {
                      onClose(closeThisModal)
                    }
                  }}
                />
              ),
            ]
          : []),
        ...(neededSteps.includes('branch')
          ? [
              ({ closeThisModal }: any) => (
                <BranchPicker increaseStep={() => onClose(closeThisModal)} />
              ),
            ]
          : []),
      ],
    })
  }

  return openPromptModal
}
